import {
  Box,
  Card,
  Container,
  List,
  ListItemText,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";

const WheelsGuide: React.FC = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const CustomCard = styled(Card)({
    borderRadius: 10,
    marginBottom: "12px",
    backgroundColor: "whitesmoke",
    padding: "20px"
  });

  const CustomTypography = styled(Typography)({
    margin: 8,
    fontFamily: "monospace",
    letterSpacing: "0.8px",
    color: "#29ADB2",
    fontWeight: "600",
  });

  const TitleTypography = styled(Typography)({
    marginBottom: "10px",
    marginTop: "8px",
    fontSize: "26px",
    color: "rgb(32, 119, 190)"
  });

  const CustomListText = styled(ListItemText)({
    margin: 8,
    fontFamily: "monospace",
    letterSpacing: "0.8px",
    color: "#29ADB2",
    fontWeight: "600",
  })

  return (
    <Container>
      <HeaderCard text={t("presentation.wheels.detail.description")} />
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.diameter.title")}
        </TitleTypography>
        <CustomTypography>
          {t("presentation.wheels.detail.diameter.description")}
        </CustomTypography>
      </CustomCard>
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.hardness.title")}
        </TitleTypography>
        <CustomTypography>
        {t("presentation.wheels.detail.hardness.description")}
        </CustomTypography>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="baseline"
          paddingTop={2}
        >
          <List disablePadding>
            <CustomListText disableTypography>F0 - 88A | XX-FIRM (86 to 88A)</CustomListText>
            <CustomListText disableTypography>F1 - 85A | X-FIRM (84 to 86A)</CustomListText>
            <CustomListText disableTypography>F2 - 84A | FIRM (82 to 84A)</CustomListText>
            <CustomListText disableTypography>F3 - 83A</CustomListText>
          </List>
        </Box>
      </CustomCard>
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.rebound.title")}
        </TitleTypography>
        <CustomTypography>
          {t("presentation.wheels.detail.rebound.description")}
        </CustomTypography>
      </CustomCard>
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.grip.title")}
        </TitleTypography>
        <CustomTypography>
          {t("presentation.wheels.detail.grip.description")}
        </CustomTypography>
      </CustomCard>
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.profile.title")}
        </TitleTypography>
        <CustomTypography>
        {t("presentation.wheels.detail.profile.description")}
        </CustomTypography>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="baseline"
          paddingTop={2}
        >
          <List disablePadding>
            <CustomListText disableTypography>

              <span>Aggressive</span> |
              {t("presentation.wheels.detail.profile.aggressive")}

            </CustomListText>
            <CustomListText disableTypography>

              <span>Hockey</span> |
              {t("presentation.wheels.detail.profile.hockey")}

            </CustomListText>
            <CustomListText disableTypography>

              <span>Freestyle/Slalom</span> |
              {t("presentation.wheels.detail.profile.freestyle")}

            </CustomListText>
            <CustomListText disableTypography>

              <span>Speed</span> |
              {t("presentation.wheels.detail.profile.speed")}

            </CustomListText>
          </List>
        </Box>
      </CustomCard>
      <CustomCard>
        <TitleTypography>
          {t("presentation.wheels.detail.hub.title")}
        </TitleTypography>
        <CustomTypography>
          {t("presentation.wheels.detail.hub.description")}
        </CustomTypography>
      </CustomCard>
    </Container>
  );
};

export default WheelsGuide;
